<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.realname" placeholder="输入教师名称" @on-search="handleSearch" style="width:100%;" />
                </Col>
                <Col span="4">
                    <Input search v-model="formItem.phone" placeholder="输入手机号" @on-search="handleSearch" style="width:100%;" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row style='margin-bottom: 20px;'>
                <Col span="10">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span="6">
                    <Select v-model="formItem.school_id" placeholder="请选择校区" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in schoolList" :value="item.school_id" :key="item.school_id">{{ item.school_name }}</Option>
                    </Select>
                </Col>
                <Col span="4">
                    <Select v-model="formItem.status" placeholder="状态" @on-change="handleSearch"  clearable style="width:160px">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
         <Modal v-model="addModel" width="800" title="修改">
            <div v-if='addModel'>
                <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                    <Row>
                        <Col span="11">
                          <FormItem label="姓名" prop='teacher_name'>
                              <Input v-model="formData.teacher_name" placeholder="请输入..."></Input>
                          </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                          <FormItem label="手机号（app登录账号）" prop='phone'>
                              <Input v-model="formData.phone" placeholder="请输入..."></Input>
                          </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                            <FormItem label="性别" prop="sex">
                                <Radio-group v-model="formData.sex">
                                    <Radio label="1">男</Radio>
                                    <Radio label="2">女</Radio>
                                    <Radio label="0">未知</Radio>
                                </Radio-group>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="身份证" prop='id_card'>
                              <Input v-model="formData.id_card" placeholder="请输入..."></Input>
                               
                            </FormItem>
                        </Col>
                        
                    </Row>
                    <Row>
                        <Col span="11">
                            <FormItem label="生日" prop='birthday'>
                               <DatePicker type="date" v-model="birthday" @on-change='changBirthday' placeholder="请选择" style="width: 200px"></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="密码（app登录密码）" prop='password'>
                              <Input v-model="formData.password" placeholder="请输入..."></Input>
                               
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle"  ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle"  @click="save('formData')">确定</Button>
            </div>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        setStatus,
        fetchInfo,
        addModify,
        setDel
    } from '@/api/teacherList'
    import {
        fetchSchoolList,

    } from '@/api/common'
    export default {
        name: 'user-components',
       
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    realname: '', 
                    start_time: '',
                    end_time: '',
                    phone: '',
                    school_id: '',
                    status:'',
                },
                start_time: '',
                end_time: '',
                teacher_id:'',
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                addModel:false,
                formData:{
                    teacher_id:'',
                    phone:'',
                    sex:'',
                    birthday:'',
                    teacher_name:'',
                    id_card:'',
                    type:0,
                    password:'',
                },//添加修改的表单数据
                statusList:[
                    {id:1,name:'封禁'},
                    {id:0,name:'正常'},
                ],
                verificationRule:{
                    phone: [
                        { required: true, message: '不能为空'}
                    ],
                    sex: [
                        { required: true, message: '不能为空'}
                    ],
                    teacher_name: [
                        { required: true, message: '不能为空'}
                    ],
                    address: [
                        { required: true, message: '不能为空'}
                    ],
                
                    birthday:[
                        { required: true, message: '不能为空'}

                    ],
                },
                schoolList:[],
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                        fixed:'left',
                    },
                    {
                        title: '姓名',
                        align: 'center',
                        key: 'realname',
                        width: 120,

                    },
                    {
                        title: '昵称',
                        align: 'center',
                        key: 'nickname',
                        width: 120,

                        
                    },
                    {
                        title: '手机号',
                        align: 'center',
                        key: 'phone',
                        width: 120, 
                    },
                    {
                        title: '身份证号',
                        align: 'center',
                        key: 'id_card',
                        width: 160,
                    },
                    {
                        title: '年龄',
                        align: 'center',
                        key: 'age',
                        width: 120,
                    },
                    {
                        title: '性别',
                        align: 'center',
                        key: 'sex',
                        width: 100,
                        render: (h, params) => {
                            if(params.row.sex==1){
                                return h('div', '男')
                            }else if(params.row.sex==2){
                                return h('div', '女')
                            }else{
                                return h('div', '未知')
                            }
                        }
                    },
                    {
                        title: '校区',
                        align: 'center',
                        key: 'school_name',
                        width: 180,
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        width: 100,
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', '封禁')
                            }else{
                                return h('div', '正常')
                            }
                        }
                        
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 240,
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.teacher_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.teacher_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.teacher_id,'确定打开该老师吗？')
                                            }
                                        }
                                    }, '打开'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.teacher_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.teacher_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.teacher_id,'确定关闭该老师吗？')
                                            }
                                        }
                                    }, '关闭'),
                                ])
                            }
                            
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
           getSchoolList(){
               fetchSchoolList().then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.schoolList=res.data;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
           },
           edit(id){
               fetchInfo({
                    teacher_id:id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.formData=res.data;
                        this.birthday=this.formData.birthday;
                        this.formData.birthday=new Date(this.formData.birthday).getTime() / 1000
                        this.addModel=true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
           },
            // 保存新增和修改
            save(name){
                this.$refs[name].validate(valid => {
                    if (valid) {
                        addModify(this.formData).then(res => {
                            res = res.data;
                            if (res.code == 200) {
                                this.getData();
                                this.addModel=false;
                            } else if(res.code==16022){
                                this.formData.type=1;
                                this.remindContent = '您拥有老师数量已经达到限额了，是否使用校区校区余额购买';
                                this.remindModal = true; 
                            }else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                    name: 'login'
                                    })
                                })
                            } else {
                            this.$Message.error(res.msg)
                            }
                        })
                    
                    }
                })
            },
            // 改变状态
            changeStatus(id,info) {
                this.teacher_id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            delete(id) {
                this.teacher_id = id;
                this.remindContent = '确定删除该老师吗？';
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                if(this.remindContent == '确定删除该老师吗？'){
                    setDel({
                        teacher_id:this.teacher_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }else{
                    setStatus({
                        teacher_id:this.teacher_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }
                    
            },
           
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
    
                }
                this.formItem.page = 1;
                this.getData();
            },
            changEndtime(time) {
    
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            changBirthday(time){
                if (time == '') {
                    this.formData.birthday = '';
    
                } else {
                    this.formData.birthday = new Date(time).getTime() / 1000
                }
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
            this.getSchoolList();
        }
    };
</script>
